import { render } from "./FeedbackSlider.vue?vue&type=template&id=5cbc13f4&scoped=true"
import script from "./FeedbackSlider.vue?vue&type=script&lang=js"
export * from "./FeedbackSlider.vue?vue&type=script&lang=js"

import "./FeedbackSlider.vue?vue&type=style&index=0&id=5cbc13f4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbc13f4"]])

export default __exports__